import { render, staticRenderFns } from "./ProgressBoard.vue?vue&type=template&id=4af97239"
import script from "./ProgressBoard.vue?vue&type=script&lang=js"
export * from "./ProgressBoard.vue?vue&type=script&lang=js"
import style0 from "./ProgressBoard.vue?vue&type=style&index=0&id=4af97239&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports